Namespace 'Customer.Filters'

class Customer.Filters.ColorPickerView extends Backbone.View
  template: JST['backbone/templates/customer/filters/components/color_picker']
  className: 'colors d-flex align-items-center'

  initialize: ({color = ''}) ->
    @color = color

  render: ->
    @$el.html @template
    @_initializeColorPicker()
    @_setInitialActiveColor()
    @$el.find('span.color').click(@_onClickColor)
    @$el.find('#custom_color').change(@_onChangeColorPicker)
    @

  getColor: =>
    @color

  _initializeColorPicker: ->
    @_customColorEl().spectrum({
      color: @color
      allowEmpty: true
      showInitial: true
      showInput: true
      chooseText: I18n.t('customer.dashboard.filters.choose_color')
      cancelText: I18n.t('customer.dashboard.filters.cancel')
    })

  _onClickColor: (event) =>
    @_keepCustomerSessionAlive()
    selectedColorEl = $(event.currentTarget)

    if selectedColorEl.hasClass('active')
      @color = ''
    else
      @color = selectedColorEl.data('value')
      activate = true
      @_customColorEl().spectrum('set', null)

    @$el.find('.color.active').removeClass('active')
    selectedColorEl.addClass('active') if activate

  _onChangeColorPicker: (event, color) =>
    @_keepCustomerSessionAlive()
    @color = color.toHexString() if color
    @$el.find('.color.active').removeClass('active') if color

  _setInitialActiveColor: ->
    @$el.find(".color[data-value='#{@color}']").addClass('active')

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  _customColorEl: ->
    @$el.find('#custom_color')

  destroyColorPicker: =>
    @_customColorEl().spectrum('destroy')
